enum WarehouseStepStatus {
    PENDING = "PENDING",
    DISPATCHED = "DISPATCHED",
}

export default WarehouseStepStatus;
